// Lodash
import _isEmpty from 'lodash/isEmpty'

// Readers
import embedUserReader from '../readers/EmbedUser'

// Utils
import loSto from '../../../config/loSto'

// Constants
import { LO_STO } from '../../../lib'
import { THEMES } from '../../../core/SukiContext'
import TENANTS from '../constants/withEmbedAuthentication.tenants'

/**
 * Extracts JWT from auth token which comprises of session token followed by JWT
 * @param {String} authToken
 * @returns {String} JWT or empty string
 */
const getJwtFromAuthToken = (authToken) => {
  const firstDotPosition = authToken?.indexOf('.')
  const jwt = authToken?.slice(firstDotPosition + 1) || ''
  return jwt
}

/**
 * Returns base64 decoded password of embed user
 * @param {Object} embedUserDetails Embed user details
 * @returns {String} password
 */
const getEmbedUserPassword = (embedUserDetails) => {
  const base64EncodedPassword = embedUserReader.oktaCreds(embedUserDetails)
  const password = window.atob(base64EncodedPassword)
  return password
}

const initializeAmwellSetup = (
  { sukiMicEnabled, pagetype, appointmentId, view },
  setTheme
) => {
  // Setup dark theme
  window.localStorage.setItem('themeMode', 'dark')
  setTheme(THEMES.DARK)

  // Store the appointment ID in local storage
  if (!_isEmpty(appointmentId)) {
    loSto.set(LO_STO.AMWELL_APPOINTMENT_ID, appointmentId)
  }
  if (!_isEmpty(sukiMicEnabled)) {
    window.localStorage.setItem('micEnabled', sukiMicEnabled !== 'false')
  }
  if (!_isEmpty(pagetype)) {
    window.localStorage.setItem('pageType', pagetype)
  }
  if (!_isEmpty(view)) {
    loSto.set(LO_STO.AMWELL_VIEW, view)
  }
}

const defaultEmbedSetupInitializer = () => {}

const TENANT_VS_INITIALIZERS = {
  [TENANTS.AMWELL]: initializeAmwellSetup
}

const initialiseEmbedClientSetup = (
  { tenantName, sukiMicEnabled, pagetype, appointmentId, view },
  setTheme
) => {
  const initializer =
    TENANT_VS_INITIALIZERS[tenantName] || defaultEmbedSetupInitializer
  initializer({ sukiMicEnabled, pagetype, appointmentId, view }, setTheme)
}

const cleanEmbedClientSetup = () => {
  window.localStorage.removeItem('themeMode')
}

export {
  getJwtFromAuthToken,
  getEmbedUserPassword,
  initialiseEmbedClientSetup,
  cleanEmbedClientSetup
}
